import React from 'react';
import { CopyableBlock } from '../CopyableBlock';

export const PolicyOutput = ({ data }) => {
  if (!data) return null;
  const full = [
    data.problem && `PROBLEM\n${data.problem}`,
    data.evidence && `EVIDENCE\n${data.evidence}`,
    data.opportunity && `OPPORTUNITY\n${data.opportunity}`,
    data.recommendation && `RECOMMENDATION\n${data.recommendation}`,
  ].filter(Boolean).join('\n\n');
  return (
    <div data-testid="output-policy">
      <CopyableBlock label="Problem" content={data.problem} testId="pol-problem" />
      <CopyableBlock label="Evidence" content={data.evidence} testId="pol-evidence" />
      <CopyableBlock label="Opportunity" content={data.opportunity} testId="pol-opportunity" />
      <CopyableBlock label="Recommendation" content={data.recommendation} testId="pol-recommendation" />
      <CopyableBlock label="Full Brief (≤200 words)" content={full} mono testId="pol-full" />
    </div>
  );
};

export const MediaOutput = ({ data }) => {
  if (!data) return null;
  return (
    <div data-testid="output-media">
      <CopyableBlock label="Headline" content={data.headline} testId="med-headline" />
      <CopyableBlock label="Sub-headline" content={data.sub_headline} testId="med-sub" />
      <CopyableBlock label="Pull quote" content={data.pull_quote} testId="med-pull" />
      <CopyableBlock label="150-word media summary" content={data.summary_150_words} testId="med-summary" />
    </div>
  );
};
